export default {"src":"/_next/static/media/diy.e675a6ca.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};